import React from "react";
import {PageHero} from "../common/PageHero";

export const History = () => {
    return (
        <>
            <PageHero title={'Historiek'}
                      badge={'Sinds 1971'}
                      lead={'Een levende en enthousiaste club!'}/>
            <div className={'ttc-section ttc-split'}>
                <article className={'ttc-card'}>
                    <p className={'ttc-eyebrow'}>Vroeger</p>
                    <p className={'ttc-card-body'}>
                        Gegroeid vanuit de chirowerking Bart te Merksem, maar werkelijk gestart in jeugdclub Grafiek,
                        destijds gevestigd in het Gildenhuis in de Gildenstraat, met drie spelers en één ploeg in de
                        competitie van KVKT (nu Sporta) in 1971. Al spoedig werden we benaderd door enkele enthousiaste
                        voetballers van de club bart Koninklijke Sport Vereniging, toen en nog steeds gevestigd in
                        Merksem, die ook wel eens een balletje wensten te slaan. Daardoor werden we in 1974 een
                        volwaardige club onder de naam Tafeltennisclub Bart, met vier heren- en twee damesploegen in de
                        competitie van het seizoen 1974-1975. Buiten de naam zijn er geen verdere banden met deze
                        voetbalclub. De naam Bart komt voort van de parochienaam Bartholomeus, waar onze club startte.
                    </p>
                    <p className={'ttc-card-body'}>
                        Gedurende de volgende jaren kenden we enkele hoogtes en laagtes met een schommelend ledenaantal
                        (20 à 60). In Merksem speelden we op verschillende locaties, met als belangrijkste de Sporthal
                        Rode Loop (vanaf 1975) en het Fort van Merksem (vanaf 2000). In 2007 beslisten we samen met
                        Merksem TTV, sinds decennia onze zusterclub binnen dezelfde lokalen, om onze werking samen te
                        voegen. Aldus ontstond in 2007 de fusieclub TTC Bart Merksem.
                    </p>
                </article>
                <article className={'ttc-card featured'}>
                    <p className={'ttc-eyebrow'}>Nu</p>
                    <p className={'ttc-card-body'}>
                        Wij spelen nog altijd in het Fort van Merksem en zijn momenteel een stabiele club met ongeveer
                        75 leden, jeugdwerking en recreanten.
                    </p>
                    <p className={'ttc-card-body'}>
                        Uiteraard is er nog steeds plek over voor gemotiveerde sporters, dus twijfel niet en kom zeker
                        eens af!
                    </p>
                </article>
            </div>
        </>
    )
}
